import { render, staticRenderFns } from "./DonateView.vue?vue&type=template&id=0668a660"
import script from "./DonateView.vue?vue&type=script&lang=ts"
export * from "./DonateView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports